import { render, staticRenderFns } from "./PwdLessOption.vue?vue&type=template&id=92d056a0&scoped=true"
import script from "./PwdLessOption.vue?vue&type=script&lang=js"
export * from "./PwdLessOption.vue?vue&type=script&lang=js"
import style0 from "./PwdLessOption.vue?vue&type=style&index=0&id=92d056a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d056a0",
  null
  
)

export default component.exports